import { Tooltip } from '../Tooltip'

import type { TooltipPreviewsProps } from './types'

import * as S from './styles'

export const TooltipExplanation = ({ data, children }: TooltipPreviewsProps) => {
  return (
    <Tooltip
      width="max-content"
      placement="top"
      title={
        <S.TooltipContent>
          {data.map((item) => (
            <S.TooltipText key={item.label}>
              <S.TooltipTitle>{item.label}</S.TooltipTitle>
              {item.text}
            </S.TooltipText>
          ))}
        </S.TooltipContent>
      }
    >
      <S.TooltipIconContainer>{children}</S.TooltipIconContainer>
    </Tooltip>
  )
}
